import type { ReactNode } from 'react';

interface Props {
  label: ReactNode;
  value: ReactNode;
  hint?: ReactNode;
  tone?: 'neutral' | 'pos' | 'neg' | 'accent';
  compact?: boolean;
}

const TONE = {
  neutral: 'text-ink-900 dark:text-ink-50',
  pos: 'text-pos-700 dark:text-pos-500',
  neg: 'text-neg-700 dark:text-neg-500',
  accent: 'text-accent-700 dark:text-accent-500',
} as const;

export function StatCard({ label, value, hint, tone = 'neutral', compact }: Props) {
  return (
    <div className={`card card-dark p-4 ${compact ? '' : 'md:p-5'}`}>
      <div className="label">{label}</div>
      <div className={`mt-1 font-mono tabular-nums ${compact ? 'text-xl' : 'text-2xl md:text-3xl'} font-bold ${TONE[tone]}`}>
        {value}
      </div>
      {hint && <div className="mt-1 text-xs text-ink-500 dark:text-ink-300">{hint}</div>}
    </div>
  );
}
